import vueComponentOptions from 'components/InputCheckbox.vue';

const CheckBoxInput = Vue.extend(vueComponentOptions);

module.exports = CheckBoxInput;
